/**
 * Validate an email address.
 * 
 * @see {@link https://stackoverflow.com/questions/8178024/email-verification-regex-failing-on-hyphens}
 * 
 * @param {String} email
 * 
 * @returns {boolean}
 */
export function validateEmail(email) {
  return /^[^@]+@[^@]+\.[^@\.]{2,}$/.test( String(email) );
}
